import React from 'react';

const SectionHeading = ({ subText, title, centerText, borderLine }) => (
  <div className={`sec-title pt-60 md-pt-30 ${borderLine ? 'mb-40 md-mb-30' : 'mb-20 md-mb-15'}`}>
    {subText && (
      <span className={`sub-text orange-color ${centerText ? 'text-center' : ''}`}>
        {subText}
      </span>
    )}
    {title && (
      <h2 className={`'title pb-30' ${centerText ? 'text-center' : ''}`}>
        {title}
      </h2>
    )}
    {borderLine && (
      <div className={`heading-border-line orange-style ${centerText ? '' : 'left-style'}`} />
    )}
  </div>
);

export default SectionHeading;
